<template>
  <div class="home" >
   <div class="container p-l-r-0 container-shadow">
    <div class="row">
      <UserProfile></UserProfile>
    </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
            <LeftNav :type="'AAE'"/>
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
          <h3 class="text-left sub-head">Schedule</h3>
         <div class="container" style="margin-top:20px;font-size:13px !important">
               <!-- subscription list   @click="ActivityMenu(data.unique_id,'chat')"-->
            <div v-for="(data,index ) in list" :key="data.id"   class="row data-list" >
                <div class="col-sm-8 left" >
                    <div class="form-check">
                        <!-- <input type="checkbox" class="form-check-input" id="service-check"> -->
                        <label class="form-check-label" for="service-check">
                            <span class="service_status">
                            Topic :  <span>{{ data.topic}}</span>
                            </span>
                        </label>
                    </div>
                    <div class="services-list">  
                        <p class="date"><span>Date:</span> {{ data.date }}</p>
                    </div>
                    <div class="services-list">  
                        <p class="date"><span>Time:</span> {{ data.time}}</p>
                    </div>
                    <a  v-if="data.inv_id !='NA'" href="javascript://" @click="Invoice(data.inv_id )" class="gobtn">Invoice</a>
                </div>
                <div class="col-sm-4 right">
                    <ul>
                        <li>
                          <span class="chat" v-if="data.details!=''">Call details : <a href="javascript://"  @click="toggleExpansion(index)">View</a></span>
                          <span class="chat" v-else>Call details : NA</span>
                        </li>
                    </ul>   
                </div>
                <div class="row">
                  <div class="col-md-12 status-table">
                      <div v-show="isExpanded(index)">
                      <table class="table table-hover roa-table">
                        <thead>
                          <th>Cal status</th>
                          <th>Phone No.</th>
                          <th>Duration</th>
                          <th>Date</th>
                      </thead>
                        <tr v-for="log in data.details" :key="log.id">
                            <td>
                              {{log.params.CustomerStatus}}
                            </td>
                            <td>
                               {{log.params.CallerID}}
                            </td>
                            <td>
                              {{formatSeconds(log.params.Duration)}}
                            </td>
                            <td>
                                {{ formatDate(log.params.created_at, 'D-MMM-YYYY hh:mm a')}}
                            </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div> 
            </div>  
          </div>
         </div>
    </div>
    
    <CommonChat/>
</div>
  </div>
</template>

<script>
// @ is an alias to /src
import LeftNav from "../layouts/leftNav.vue"
import Invoice from '../../services/invoice';
import CommonChat from "../../components/common_chat.vue"
import UserProfile from "../layouts/profile-header.vue"
import ask_en_expert from "../../services/ask_an_expert"
import moment from 'moment'
import 'moment-duration-format';
export default {
  name: 'ask_en_expert',
  data(){
    return {
      list:{},
      showModal:false,
       file_path:process.env.VUE_APP_URL,
       expandedGroup: []
    }
  },
  components: {
    LeftNav,
    CommonChat,
    UserProfile
  },
  computed:{
  },
  methods: {
    formatSeconds(seconds){
     var duration= moment.duration(seconds, 'seconds');
      return  duration.format("hh:mm:ss");
    },
    formatDate(date,format){
             return moment(date).format(format);
    },
    isExpanded(key) {
    	  return this.expandedGroup.indexOf(key) !== -1;
    },
    toggleExpansion(key) {
    	if(this.isExpanded(key)){
      	this.expandedGroup.splice(this.expandedGroup.indexOf(key), 1);
      }
      else{
      	this.expandedGroup.push(key);
      }
    },
    Invoice(invId){
    Invoice.get({'subscription_id':invId,'from':'aae'})
            .then(res=>{
                var response = res.data;
                  const url = this.file_path + response.path + "/" + response.file;
                  const link = document.createElement("a");
                  link.href = url;
                  link.target = '_blank';
                  link.type = 'application/octet-stream';
                  link.download=response.file
                  // link.setAttribute("download", response.file); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                  // link.remove();
            })
                    // .catch(err=>{console.log(err)});
        }
  },
  created(){
    //  this.$store.dispatch('user/fetchUsers')
    ask_en_expert.get()
      .then(response=>{
        if(response.data.list.length>0){
          this.list=response.data.list
        }
      })
  }
}
</script>
<style scoped>
.modal-active{
	display:block;
}
</style>
